import * as React from 'react';
import { ArticleParagraph1, UIText3 } from '@cian/ui-kit';

import * as styles from './BottomContent.css';
import { IPromoProp } from '../../../../types/promosPage';

interface IBottomContentProps {
  promoProps: IPromoProp[];
}

export const BottomContent: React.FC<IBottomContentProps> = ({ promoProps }) => {
  if (!promoProps.length) {
    return null;
  }

  return (
    <ul className={styles['bottom-content']} data-testid="PromoItemFactoids">
      {promoProps.map((prop, index) => (
        <li className={styles['factoid']} key={index}>
          <UIText3 color="gray60_100">{prop.title}</UIText3>
          <ArticleParagraph1>{prop.value}</ArticleParagraph1>
        </li>
      ))}
    </ul>
  );
};
